import { jsx as _jsx } from "react/jsx-runtime";
import { KevelBanners } from '../../Shared/KevelBanners/KevelBanners.js';
export const DesktopSecondaryKevelBanners = ({ kevelAds }) => {
    return (_jsx(KevelBanners, { kevelAds: kevelAds, ga4SubFeature: "secondary_location", variation: "desktop", imageSizes: "(min-width: 1400px) 414px, 30.5vw" }));
};
//# sourceMappingURL=DesktopSecondaryKevelBanners.js.map